import api from '@/services/api';
import Resource from '@/services/resources/common';

export default class ReportUniverseFieldResource extends Resource {
  constructor(entrypoint = '/universe_fields', alias = 'ReportUniverseField') {
    super(entrypoint, alias);
  }
}
